import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const importantDataForm: Form<Client> = {
  key: 'importantData',
  title: 'Wichtige Informationen',
  fields: [
    {
      key: 'minorChildren',
      label: 'Kinder unter 18',
      fieldTypes: 'checkbox',
      xsWidth: 'auto',
    },
    {
      key: 'singleParent',
      label: 'Alleinerziehend',
      fieldTypes: 'checkbox',
      xsWidth: 'auto',
    },
    {
      key: 'immigrationBackground',
      label: 'Migrationshintergrund',
      fieldTypes: 'checkbox',
      xsWidth: 'auto',
    },
    {
      key: 'fleeingBackground',
      label: 'Fluchthintergrund',
      fieldTypes: 'checkbox',
      xsWidth: 'auto',
    },
    {
      key: 'translationNecessary',
      label: 'Sprachmittlung nötig',
      fieldTypes: 'checkbox',
      xsWidth: 'auto',
    },
    {
      key: 'fleeingBackgroundResidenceStatus',
      label: 'Aufenthaltsstatus',
      fieldTypes: 'text',
      isVisible: (client) => client.fleeingBackground != null && client.fleeingBackground === true,
    },
    {
      key: 'partnerHasMentalIllness',
      label: 'Partner*in hat eine psychische Erkrankung',
      fieldTypes: 'checkbox',
      xsWidth: 'auto',
    },
    {
      key: 'partnerHasAddiction',
      label: 'Partner*in hat eine Suchterkrankung',
      fieldTypes: 'checkbox',
      xsWidth: 'auto',
    },
    {
      key: 'importantCaregiver',
      label: 'Wichtige Bezugspersonen/Anbindung',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
    {
      key: 'language',
      label: 'Sprache',
      fieldTypes: 'text',
    },
    {
      key: 'highRisk',
      label: 'Hochrisiko',
      fieldTypes: 'select',
      options: [
        {
          value: 'threatManagementIntern',
          label: 'Bedrohungsmanagement intern',
        },
        {
          value: 'threatManagementExtern',
          label: 'Bedrohungsmanagement extern',
        },
      ],
    },
    {
      key: 'charge',
      label: 'Anzeige',
      fieldTypes: 'select',
      options: [
        {
          value: 'pressed',
          label: 'getätigt',
        },
        {
          value: 'planned',
          label: 'geplant',
        },
        {
          value: 'notDesired',
          label: 'nicht gewünscht',
        },
        {
          value: 'notRelevant',
          label: 'nicht relevant',
        },
        {
          value: 'stillUnsure',
          label: 'noch unsicher',
        },
        {
          value: 'unknown',
          label: 'unbekannt',
        },
      ],
    },
    {
      key: 'confidentialTraceability',
      label: 'Vertrauliche Spurensicherung',
      fieldTypes: 'checkbox',
    },
    {
      key: 'profession',
      label: 'Berufliche Situation',
      fieldTypes: 'select',
      options: [
        {
          value: 'apprenticeship',
          label: 'in Ausbildung',
        },
        {
          value: 'employed',
          label: 'erwerbstätig',
        },
        {
          value: 'unemployed',
          label: 'arbeitslos',
        },
        {
          value: 'school',
          label: 'Schule',
        },
        {
          value: 'studying',
          label: 'Studium',
        },
        {
          value: 'careWork',
          label: 'Care-Arbeit',
        },
        {
          value: 'sickLeave',
          label: 'im Krankenstand',
        },
        {
          value: 'pension',
          label: 'Rente',
        },
        {
          value: 'euPension',
          label: 'EU-Rente',
        },
        {
          value: 'professionOther',
          label: 'Sonstiges',
        },
        {
          value: 'unknown',
          label: 'unbekannt',
        },
      ],
    },
    {
      key: 'professionOther',
      label: 'Sonstige berufliche Situation',
      fieldTypes: 'text',
      isVisible: (client) => client.profession != null && client.profession === 'professionOther',
    },
    {
      key: 'unemployed',
      label: 'Bezogene Leistung',
      fieldTypes: 'text',
      isVisible: (client) => client.profession != null && client.profession === 'unemployed',
    },
  ],
};

export default importantDataForm;
